import React, { forwardRef } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  className = '',
  ...props
}, ref) => {
  return <div className="w-full flex flex-col gap-1.5" data-id="element-475">
        {label && <label className="font-mono text-xs text-muted-foreground uppercase tracking-widest" data-id="element-476">
            {label}
          </label>}
        <input ref={ref} className={`flex h-10 w-full rounded-none border border-border bg-background px-3 py-2 font-mono text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-primary focus-visible:ring-1 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50 ${className}`} {...props} data-id="element-477" />
        {error && <span className="font-mono text-xs text-destructive" data-id="element-478">{error}</span>}
      </div>;
});
Input.displayName = 'Input';